import { createFileRoute } from '@tanstack/react-router';
import { PayPage } from '../../features/settlement';

export const Route = createFileRoute('/portal/settlement/pay')({ component: PayPage });
